import { useEffect, useState } from "react";
import axios from "axios";
import { InstagramLogo } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { INSTAGRAM_URL } from "@/data/content";
import { useLanguage } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InstagramRow() {
  const { t } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/instagram/posts`)
      .then((r) => setPosts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section data-testid="instagram-section" className="mx-auto max-w-7xl px-6 pb-24 md:px-12 md:pb-36">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-gold/80">{t.ig.overline}</p>
          <h2 className="mt-3 font-serif text-2xl uppercase tracking-wide text-[#FAFAFA] md:text-3xl">{t.ig.title}</h2>
        </div>
        <a
          data-testid="instagram-follow-button"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 border border-gold/40 px-5 py-2.5 text-[10px] uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:bg-gold hover:text-charcoal"
        >
          <InstagramLogo size={16} weight="duotone" /> @moubarak.charbel
        </a>
      </Reveal>
      <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={(i % 4) * 0.08}>
            <a
              data-testid={`instagram-post-${i}`}
              href={p.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden border border-gold/10"
            >
              <img src={p.image_url} alt={p.caption || "Instagram post"} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 flex items-center justify-center bg-charcoal/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <InstagramLogo size={32} weight="duotone" className="text-gold" />
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
